import { API } from "@/utils/api";

/* Get all sves */
export const getSves = async () => {
  const response = await API().get(`/sves`);
  return response.data.data.sves;
};
